import { useQuery } from '@tanstack/react-query';
import { securityAlertsApi } from '../api/securityAlerts';

export function useSecurityAlerts() {
  return useQuery({
    queryKey: ['security-alerts', 'summary'],
    queryFn: securityAlertsApi.getSummary,
    refetchInterval: 30_000,
    staleTime: 15_000,
  });
}
